import React from 'react';
import './PackDashboard.css';
import { ListProps } from "react-admin";
import AIIntegrationList from "@src/components/AIIntegration/AIIntegrationList";

const PackDashboard = (props: ListProps) => {
    return <AIIntegrationList />
}

export default PackDashboard;